import { useCallback } from 'react';
import { createGlobalState } from 'react-use';
import useRecord from './useRecord';
import useData from './useData';
import useConfig from './useConfig';

const initialState = {
	relatedExhibitorsFromAPI: [],
};

const useRecommendState = createGlobalState(initialState);

const useRecommend = () => {
	const { uuid, userid } = useRecord();
	const [configState, setConfigState] = useRecommendState(initialState);
	const { exhibitorInfo } = useData();
	const { recommendFromAPI } = useConfig();

	const fetchRecommend = useCallback((triggerID_1) => {
		if (!recommendFromAPI) return false;
		fetch('https://nas.bizlion.com.tw:8008/cf/recommendation_v1/run', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify([{
				uuid,
				userid,
				triggerID_1,
				triggerID_2: '',
				triggerID_3: '',
			}]),
		})
			.then((response) => {
				return response.text();
			})
			.then((data) => {
				const array = data.split(',');
				const exhibitors = array.slice(-3);
				const result = exhibitors.map((exhibitor) => {
					exhibitor = exhibitor.replace(/(\r\n|\n|\r)/gm, '');
					return exhibitor;
				});
				const relatedExhibitors = exhibitorInfo.filter((exhibitor) => result.includes(exhibitor['攤位號碼']));

				setConfigState({
					relatedExhibitorsFromAPI: relatedExhibitors,
				});
			});

	}, [exhibitorInfo, recommendFromAPI, setConfigState, userid, uuid]);

	return {
		...configState,
		fetchRecommend,
	};
}
export default useRecommend;